interface FormatNumberProps {
    number: number;
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
}

export const formatNumber = ({ number, minimumFractionDigits = 0, maximumFractionDigits = 3 }: FormatNumberProps) => {
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits,
        maximumFractionDigits,
    }).format(number);
};
